module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.getIsDownloadingInvoiceResumeBulk) ? _c('div', {
    staticClass: "d-flex w-100 justify-content-center my-4"
  }, [_c('loader')], 1) : _c('div', {
    staticClass: "mt-2 d-flex"
  }, [_c('button', {
    staticClass: "btn tertiary full super mr-3",
    class: {
      'blue': _vm.invoiceTo == 'customer'
    },
    on: {
      "click": function($event) {
        return _vm.setInvoiceTo('customer')
      }
    }
  }, [_vm._v("Customer")]), _vm._v(" "), _c('button', {
    staticClass: "btn tertiary full super",
    class: {
      'blue': _vm.invoiceTo == 'agent'
    },
    on: {
      "click": function($event) {
        return _vm.setInvoiceTo('agent')
      }
    }
  }, [_vm._v("Agent")])]), _vm._v(" "), (_vm.invoiceTo) ? _c('div', {
    staticClass: "mt-2 d-flex justify-content-end"
  }, [(_vm.invoiceResumeBulk) ? _c('div', [_c('label', [_vm._v("\n                    Amount to invoice\n                ")]), _vm._v(" "), (_vm.getIsDownloadingInvoiceResumeBulk) ? _c('div', [_c('loader')], 1) : _c('div', {
    staticClass: "fs-large text-right darker bold"
  }, [_vm._v(_vm._s(_vm.formatPrice(_vm.valueToInvoice)) + "€")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.invoiceTo == 'agent') ? _c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    class: {
      'color-6': _vm.$v.invoiceToForm.vat.$invalid
    }
  }, [_vm._v("\n                    VAT Number\n                ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.invoiceToForm.vat),
      expression: "invoiceToForm.vat"
    }],
    staticClass: "full mb-3",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.invoiceToForm.vat)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.invoiceToForm, "vat", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    class: {
      'color-6': _vm.$v.invoiceToForm.city.$invalid
    }
  }, [_vm._v("\n                    City "), (_vm.isInvoiceValueOver) ? _c('span', {
    staticClass: "color-6"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.invoiceToForm.city),
      expression: "invoiceToForm.city"
    }],
    staticClass: "full mb-3",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.invoiceToForm.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.invoiceToForm, "city", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("\n                    Postal Code\n                ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.invoiceToForm.postalCode),
      expression: "invoiceToForm.postalCode"
    }],
    staticClass: "full mb-3",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.invoiceToForm.postalCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.invoiceToForm, "postalCode", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    class: {
      'color-6': _vm.$v.invoiceToForm.country.$invalid
    }
  }, [_vm._v("\n                    Country "), (_vm.isInvoiceValueOver) ? _c('span', {
    staticClass: "color-6"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('country-picker', {
    attrs: {
      "openDirection": 'bottom',
      "selectedCountryValue": _vm.selectedCountry,
      "disabled": false,
      "allowEmpty": false
    },
    on: {
      "input": function($event) {
        return _vm.updateCountry($event)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', {
    class: {
      'color-6': _vm.$v.invoiceToForm.businessName.$invalid
    }
  }, [_vm._v("\n                    Billing name\n                ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.invoiceToForm.businessName),
      expression: "invoiceToForm.businessName"
    }],
    staticClass: "full mb-3",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.invoiceToForm.businessName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.invoiceToForm, "businessName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', {
    class: {
      'color-6': _vm.$v.invoiceToForm.address.$invalid
    }
  }, [_vm._v("\n                    Address "), (_vm.isInvoiceValueOver) ? _c('span', {
    staticClass: "color-6"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.invoiceToForm.address),
      expression: "invoiceToForm.address"
    }],
    staticClass: "full mb-3",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.invoiceToForm.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.invoiceToForm, "address", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.invoiceTo) ? _c('div', {
    staticClass: "d-flex align-items-center mt-4 mb-5"
  }, [_c('div', {
    staticClass: "flexGrow1 d-flex"
  }, [(_vm.getIsPrintingInvoice) ? _c('div', {
    staticClass: "d-flex"
  }, [_c('loader'), _vm._v(" "), _c('div', [_vm._v("Downloading invoice please wait")])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-5"
  }, [(!_vm.getIsDocumentTypesLoading) ? _c('v-select', {
    attrs: {
      "options": _vm.documentTypesOptions,
      "label": "label",
      "value": _vm.documentTypeSelected
    },
    on: {
      "input": _vm.updateDocType
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('button', {
    staticClass: "btn blue wider text-nowrap",
    attrs: {
      "disabled": _vm.getIsCreatingInvoice || _vm.$v.$invalid || _vm.getIsPrintingInvoice || _vm.getIsDownloadingInvoiceResumeBulk || _vm.formatPrice(_vm.valueToInvoice) == 0 || _vm.formatPrice(_vm.valueToInvoice) == null
    },
    on: {
      "click": _vm.emitInvoices
    }
  }, [_vm._v("Create Invoice(s)")])]) : _vm._e()])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-16a63f3c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16a63f3c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ReservationsBulkActions/areaInvoice.vue
// module id = 2075
// module chunks = 0